export const Styles = {
  maxHeightContainer: {
    maxHeight: "100%",
    display: "grid",
    gridTemplateRows: "auto auto 1fr",
  },

  maxHeight: {
    maxHeight: "100%",
  },

  maxHeightMinWidth: {
    maxHeight: "100%",
    minWidth: "100%",
  },

  overflowY: {
    overflowY: "auto",
  },

  maxHeightContainerNoFlex1: {
    maxHeight: "100%",
    display: "flex",
    flexDirection: "column",
  },

  anchortagStyling: {
    color: "#6487C3",
    textDecoration: "none",
  },
} as const;
